@if (component != 'editMetadata') {
  <div class="row mb-0 pb-0">
    <div class="col-12 row mb-0 pb-0">{{title |translate}}
      @if (popupContent !== null) {
        <i class="far fa-info float-right btn btn-link" title="Display Help"></i>
      }
    </div>
  </div>
}
@if (component === 'editMetadata') {
  <div class="row text-center">
    <div class="col-12 text-center">{{title |translate}}
      @if (popupContent !== null) {
        <i class="far fa-info btn btn-link" title="" (mouseenter)="openPopup($event)" (mouseleave)="closePopup($event)"></i>
      }
      @if (showPopup) {
        <div class="popup position-fixed card shadow border-dark p-3" >
          {{popupContent |translate}}
        </div>
      }
    </div>
  </div>
}
<div class="row mt-0 pt-0">
  <div class="col-12 mt-0 pt-0" [ngClass]="{'radio-button-disabled': disabled}">
    @for (option of options; track option; let i = $index) {
      <span class="radio-container">
        <input [disabled]="disabled" type="radio" class="radio-custom" [value]="option" (click)="selectOption(option)" [checked]="clicked[i]">
        <span class="radio-custom-text text-primary font-weight-bold">{{option |translate | titlecase}}</span>
      </span>
    }
  </div>
</div>
